import { find } from 'lodash'
import React, { Fragment, useState } from 'react'
import Select from 'UI/Select'
import { updateVM } from './update'

const setClient = (vm, updateVMs) => {
  updateVM({
    vm,
    updateVMTableData: updateVMs,
    patchData: {
      client_data_source: 'Manual',
      viaje_client_id: vm.temporary_viaje_client_id,
      client_id_manually_set: true
    }
  })
}

const SetClient = ({ vm, updateVMs, customerOptions }) => {
  const [showSelectBox, setShowSelectBox] = useState(false)

  if (showSelectBox) {
    return (
      <Fragment>
        <div className="row mb-3">
          <div className="col">
            <Select
              options={customerOptions}
              value={find(customerOptions, ['value', (vm.temporary_viaje_client_id || vm.viaje_client_id)])}
              onChange={(option) => updateVMs({ ...vm, temporary_viaje_client_id: option.value })}
            />
          </div>
        </div>

        <div className="row">
          <div className="col">
            <button className='btn btn-primary' onClick={() => setClient(vm, updateVMs)}>
              Update VM
            </button>
          </div>

          <div className="col">
            <button className='btn btn-danger btn-outline' onClick={() => setShowSelectBox(false)}>
              Cancel
            </button>
          </div>
        </div>
      </Fragment>
    )
  }

  return (
    <button className='btn btn-primary' onClick={() => setShowSelectBox(true)}>
      Change client
    </button>
  )
}

export default SetClient
